import React from 'react';
import StandardAIDetail from './StandardAIDetail';

// Custom template for Policy Rules - can be customized later
const PolicyRulesDetail = ({ card }) => {
  // For now, use the standard template
  // You can customize this component with specific UI for Policy Rules
  return <StandardAIDetail card={card} />;
};

export default PolicyRulesDetail;
